import { auth as firebaseAuth } from "@/app/_lib/firebase/client";
import {
  createNativeSignInHelpers,
  isCapacitorNative,
} from "@medly/auth-config/native-sign-in";

const { nativeAppleSignIn, nativeGoogleSignIn, nativeMicrosoftSignIn } =
  createNativeSignInHelpers(firebaseAuth);

export {
  isCapacitorNative,
  nativeAppleSignIn,
  nativeGoogleSignIn,
  nativeMicrosoftSignIn,
};
